import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import OrderCreateUI from './OrderCreateUI.js'

class OrderCreateSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      errorCode: null,
      // order name
      orderName: '',
      orderNameError: null,
      // customerId
      customerId: '',
      customerIdList: null,
      // dueDate
      dueDate: '',
      dueDateError: null,
      // order name
      expectedMargin: '',
      expectedMarginError: null,
      // form events
      submitted: false,
    }
  }

  render() {
    return (
      <OrderCreateUI
        context={this.props.context}
        messageList={this.props.messageList}
        errorList={this.state.errorList}
        errorCode={this.state.errorCode}
        successMsg={this.state.successMsg}
        // order name
        orderName={this.state.orderName}
        onOrderNameChange={(event) => {this.setState({orderName: event.target.value})}}
        orderNameError={this.state.orderNameError}
        setOrderNameError={(error) => {this.setState({orderNameError: error})}}
        // customerId
        customerId={this.state.customerId}
        customerIdList={this.state.customerIdList}
        onCustomerIdChange={(event) => {this.setState({customerId: event.target.value})}}
        // dueDate
        dueDate={this.state.dueDate}
        onDueDateChange={(selectedDateISO) => {
          this.setState({dueDate: selectedDateISO})
        }}
        dueDateError={this.state.dueDateError}
        setDueDateError={(error) => {this.setState({dueDateError: error})}}
        // order name
        expectedMargin={this.state.expectedMargin}
        onExpectedMarginChange={(event) => {this.setState({expectedMargin: event.target.value})}}
        expectedMarginError={this.state.expectedMarginError}
        setExpectedMarginError={(error) => {this.setState({expectedMarginError: error})}}
        // form events
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        setErrorList={this.setErrorList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getCustomers(context)
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/accounts/${this.props.context.session.accountId}/customers/${this.state.customerId}/estimates`,
      this.onSubmitCallback, {
        estimateName: this.state.orderName,
        dueDate: this.state.dueDate,
        expectedMargin: this.state.expectedMargin,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
      switch(error.fieldName) {
        case 'orderName':
          this.setState({orderNameError: error.message})
          break;
        case 'dueDate':
          this.setState({dueDateError: error.message})
          break;
        case 'expectedMargin':
          this.setState({expectedMarginError: error.message})
          break;
        default:
      }
      if (error.errorCode)
        this.setState({errorCode: error.errorCode}) // 'SubscriptionNotActive'
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    let context = this.props.context
    if (this.state.errorList.length === 0) {
      CacheManager.removeObject(CacheKeys.Orders(context.session.accountId))
      setTimeout(() => {
        this.props.history.push(`/orders/${response.estimate.id}/items`)
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
    if (errorList && errorList.length > 0)
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
  }

  getCustomers(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/customers`,
      cacheKey: CacheKeys.Customers(context.session.accountId),
      callback: this.getCustomersCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getCustomersCallback = (response) => {
    if (response.customerList.length === 0) {
      // create page will not be reached without a customers
      // just redirect from here
      this.props.history.push('/settings/account/customers/create')
      return
    }

    let customerIdList = response.customerList.map(customer => ({
      key: customer.customerId,
      value: customer.customerName
    }))
    this.setState({
      customerIdList: customerIdList,
      customerId: customerIdList[0].key
    })
  }
}

export default withRouter(OrderCreateSF)
